import type { MarketingTrafficContext } from "@/lib/analytics-traffic";

export type MarketingEventAudience = "all" | "public_only";

type MarketingTrafficClassification = Pick<
  MarketingTrafficContext,
  "analytics_excluded" | "traffic_kind"
>;

type DispatchMarketingEventForTrafficInput = {
  analyticsAudience: MarketingEventAudience;
  trafficContext: MarketingTrafficClassification;
  send: () => void;
};

export function dispatchMarketingEventForTraffic({
  analyticsAudience,
  trafficContext,
  send,
}: DispatchMarketingEventForTrafficInput) {
  if (
    analyticsAudience === "public_only"
    && (trafficContext.analytics_excluded || trafficContext.traffic_kind !== "public")
  ) {
    return false;
  }

  send();
  return true;
}
